import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-simulador-preco',
  templateUrl: './simulador-preco.component.html',
  styleUrls: ['./simulador-preco.component.scss']
})
export class SimuladorPrecoComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit(): void {
  }
}
